export enum AutomaticStatusWaiting {
  BEFORE_FLAIR_UPLOAD = 'before_flair_upload',
  FLAIR_UPLOADED = 'flair_uploaded',
  BEFORE_STREAMED_UPLOAD = 'before_streamed_upload',
  STREAMED_UPLOADED = 'streamed_uploaded',
  BEFORE_OCR_UPLOAD = 'before_ocr_upload',
  OCR_UPLOADED = 'ocr_uploaded',
  BEFORE_AI_SUGGEST = 'before_ai_suggest',
  AI_SUGGESTED = 'ai_suggested',
}

export enum TimestampStatusCreating {
  CREATING = 'creating',
}
